import { useWindowDimensions } from "hooks/useWindowDimensions";

export const useSlidesToShow = () => {
  const { width } = useWindowDimensions();
  const slidesToShow = () => {
    const screenSize = width;
    switch (true) {
      case screenSize <= 768:
        return 3.5;
      case screenSize < 1200:
        return 5.5;
      default:
        return 6;
    }
  };

  const isMobile = width <= 768;
  return {
    numberOfSlidesToShow: slidesToShow(),
    isMobile
  };
};
